module.exports = __webpack_public_path__ + "img/DNARepair-BRME_GSE179572.100e223e.png";